export const routes = {
    web: {
        index: '/',
        indexLogout: '/?logout=true',
        termsAndConditions: '/terms-and-conditions',
        featureList: '/#featureList',
        pricing: '/pricing',
        faq: '/faq',
        waitingList: '/waiting-list',
        contact: '/contact',
        marketingCommunicationTerms: '/marketing-communication-terms',
        privacyPolicy: '/privacy-policy',
        affiliate: '/affiliate',
        affiliateTerms: '/affiliate/podminky',
        compoundInterest: '/kalkulacka-slozeneho-uroceni',
    },
    app: {
        index: '/app',
        maintenance: '/app/maintenance',
        pricing: '/app/pricing',
        pastDue: '/app/past-due',
        affiliate: '/app/affiliate',
        affiliateMonth: '/app/affiliate/month',
        sharedPortfolio: '/app/portfolio',
        invested: '/app/invested',
        profits: '/app/profits',
        dividends: '/app/dividends',
        taxReport: '/app/tax-report',
        profile: '/app/profile',
        portfolios: '/app/portfolios',
        symbols: '/app/symbols',
        assets: {
            stocks: '/app/assets/stocks',
            personal: '/app/assets/personal',
            investown: '/app/assets/investown',
        },
        users: '/app/users',
        watchlist: '/app/watchlist',
        portfolioList: '/app/portfolio-list',
        faq: '/app/faq',
        leaderboard: '/app/leaderboard',
        admin: {
            dashboard: '/app/admin/dashboard',
            statistics: '/app/admin/statistics',
            analytics: '/app/admin/analytics',
            users: '/app/admin/users',
            portfolios: '/app/admin/portfolios',
            alternativeSymbols: '/app/admin/alternative-symbols',
            criticalNotifications: '/app/admin/critical-notifications',
            importers: '/app/admin/importers',
            campaignLinks: '/app/admin/campaign-links',
            symbols: '/app/admin/symbols',
        },
    },
};
